<template>
  <div>
   <div class="flex items-center justify-between mb-3">
    <div v-if="vehicles && vehicles.length > 0" class="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2">
      {{ listTitle }} ({{ vehicles.length }})
    </div>
    <button class="bg-blue-400 text-sm text-white p-1 rounded-md cursor-pointer" v-if="selectedVehicles.length>0"
      @click="bulkAssignVahicle"    
    >
      <i class="fas fa-plus mr-1 text-xs" ></i>
      {{selectedVehicles.length}} Aracı Ata
    </button>
   </div> 
    
    <div v-if="loading" class="py-2 text-center">
      <div class="w-5 h-5 border-2 border-t-red-500 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin mx-auto mb-1"></div>
      <p class="text-xs text-gray-500 dark:text-gray-400">Araçlar yükleniyor...</p>
    </div>
    
    <div v-else-if="vehicles && vehicles.length > 0" class="space-y-2">
      <div 
        v-for="vehicle in vehicles" 
        :key="vehicle.id"
        class="flex items-center justify-between p-2 border-b border-gray-100 dark:border-gray-700 last:border-b-0"
        :class="[
          { 
            'border-l-2 border-amber-500': hasActiveJob(vehicle),
            'bg-blue-100': isSelected(vehicle) // Seçiliyse arka plan ver
          }
        ]"
        @click="toggleVehicle(vehicle)"
      >
        <div class="flex items-center flex-1 mr-3">
          <div class="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 mr-3 flex-shrink-0">
            <i class="fas fa-truck text-gray-500 dark:text-gray-300 text-sm"></i>
          </div>
          <div class="min-w-0 flex-1">
            <div class="font-medium text-sm truncate flex items-center">
              <span>{{ vehicle.plate || vehicle.vehicle }}</span>
              <!-- İş durumu etiketi -->
              <span 
                v-if="hasActiveJob(vehicle)" 
                class="ml-2 px-1.5 py-0.5 text-[10px] rounded bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400 inline-flex items-center"
              >
                <i class="fas fa-clock text-[8px] mr-1"></i>Aktif İş
              </span>
            </div>
            <div class="flex items-center flex-wrap text-xs text-gray-500 dark:text-gray-400">
              <div class="flex items-center mr-2">
                <i class="fas fa-user text-gray-400 mr-1"></i>
                <span class="truncate max-w-[120px]">{{ vehicle.driverName || 'Sürücü Yok' }}</span>
              </div>
              <div class="flex items-center mr-2">
                <i class="fas fa-map-marker-alt text-red-400 mr-1"></i>
                <span>{{ Math.round(vehicle.distance) }}km</span>
              </div>
              <!-- İş bilgileri -->
              <template v-if="hasActiveJob(vehicle)">
                <!-- İş bitiş zamanı -->
                <div v-if="vehicle.jobEndTime" class="flex items-center mt-0.5 w-full">
                  <i class="fas fa-calendar-check text-amber-500 mr-1 text-[10px]"></i>
                  <span class="text-amber-600 dark:text-amber-400 text-[10px]">İş Bitiş: {{ formatTime(vehicle.jobEndTime) }}</span>
                </div>
                <!-- Mevcut sipariş numaraları -->
                <div v-if="vehicle.orderNos && vehicle.orderNos.length > 0" class="flex items-center mt-0.5 w-full">
                  <i class="fas fa-clipboard-list text-amber-500 mr-1 text-[10px]"></i>
                  <span class="text-amber-600 dark:text-amber-400 text-[10px]">
                    Aktif İş: {{ vehicle.orderNos.join(', ') }}
                  </span>
                </div>
                <!-- Hedef nokta -->
                <div v-if="vehicle.planning && vehicle.planning.targetPointName" class="flex items-center mt-0.5 w-full">
                  <i class="fas fa-map-pin text-amber-500 mr-1 text-[10px]"></i>
                  <span class="text-amber-600 dark:text-amber-400 text-[10px] truncate">
                    Hedef: {{ vehicle.planning.targetPointName }}
                  </span>
                </div>
              </template>
              <!-- Maliyet bilgisi varsa göster -->
              <div v-if="showCost && vehicle.recomendationTotalCost" class="flex items-center mt-0.5">
                <i class="fas fa-dollar-sign text-green-500 mr-1"></i>
                <span class="text-green-600 dark:text-green-400">{{ formatCost(vehicle.recomendationTotalCost) }}</span>
              </div>
              <!-- Yıkama maliyeti varsa göster -->
              <div v-if="showCost && vehicle.washCost && vehicle.washCost > 0" class="flex items-center mt-0.5 ml-2">
                <i class="fas fa-shower text-blue-500 mr-1"></i>
                <span class="text-blue-600 dark:text-blue-400">{{ formatCost(vehicle.washCost) }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <button
          @click="assignVehicle(vehicle)"
          class="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded-md text-sm transition-colors flex-shrink-0"
          :class="{'bg-amber-500 hover:bg-amber-600': hasActiveJob(vehicle)}"
        >
          <i class="fas fa-plus mr-1 text-xs" :class="{'fa-exclamation-triangle': hasActiveJob(vehicle)}"></i>
          Ata
        </button>
      </div>
    </div>
    
    <div v-else class="py-3 text-center">
      <p class="text-xs text-gray-500 dark:text-gray-400">{{ emptyMessage }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiveAssignmentVehicleList",
  props: {
    vehicles: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: 'nearby', // 'nearby' veya 'recommended'
      validator: (value) => ['nearby', 'recommended'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedVehicles: [] // Seçilen araçlar
    };
  },
  computed: {
    emptyMessage() {
      return this.type === 'recommended' 
        ? 'Önerilen benzersiz araç bulunamadı' 
        : 'Yakında uygun araç yok';
    },
    showCost() {
      return this.type === 'recommended';
    },
    listTitle() {
      return this.type === 'recommended' 
        ? 'Önerilen Benzersiz Araçlar' 
        : 'Yakındaki Araçlar';
    }
  },
  methods: {
    toggleVehicle(vehicle) {
      const index = this.selectedVehicles.findIndex(v => v.id === vehicle.id);
      if (index === -1) {
        this.selectedVehicles.push(vehicle);
      } else {
        this.selectedVehicles.splice(index, 1);
      }
    },
    isSelected(vehicle) {
      return this.selectedVehicles.some(v => v.id === vehicle.id);
    },
    hasActiveJob(vehicle) {
      // Araç durumu kontrolü yapmak için birkaç farklı kontrol yapalım
      // 1. hasActiveJob özelliği varsa doğrudan kullan
      if (vehicle.hasActiveJob !== undefined) {
        return vehicle.hasActiveJob;
      }
      
      // 2. orderNos dizisi varsa ve boş değilse, aracın işi var demektir
      if (vehicle.orderNos && Array.isArray(vehicle.orderNos) && vehicle.orderNos.length > 0) {
        return true;
      }
      
      // 3. planning nesnesi varsa ve isStopped 0 ise, aracın işi var demektir
      if (vehicle.planning && vehicle.planning.isStopped === 0) {
        return true;
      }
      
      // Varsayılan olarak, aracın işi yok
      return false;
    },
    formatCost(cost) {
      if (!cost) return '-';
      return new Intl.NumberFormat('tr-TR', { 
        style: 'currency', 
        currency: 'TRY',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(cost);
    },
    formatTime(dateTime) {
      if (!dateTime) return '-';
      
      // ISO string ise veya tarih objesi ise
      if (typeof dateTime === 'string' || dateTime instanceof Date) {
        return new Date(dateTime).toLocaleDateString('tr-TR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
      
      return dateTime;
    },
    bulkAssignVahicle(){
       this.$emit('bulkAssign', this.selectedVehicles)  
    },
    assignVehicle(vehicle) {
      // Araç durumuna göre farklı uyarı mesajları
      if (this.hasActiveJob(vehicle)) {
        // İşi olan araç için detaylı onay
        let warningHtml = `<div class="text-left">
          <p class="mb-2"><strong>${vehicle.plate || vehicle.vehicle}</strong> plakalı araç şu anda başka bir sipariş üzerinde çalışıyor.</p>
          <p class="mb-2">Bu iş araca <strong>2. iş olarak</strong> atanacak ve mevcut işi <strong>bittikten sonra</strong> atanacaktır.</p>`;
        
        // İş bitiş zamanı varsa göster
        if (vehicle.jobEndTime) {
          warningHtml += `<p class="text-amber-600">Mevcut İş Bitiş: ${this.formatTime(vehicle.jobEndTime)}</p>`;
        }
        
        // Aktif siparişler varsa göster
        if (vehicle.orderNos && vehicle.orderNos.length > 0) {
          warningHtml += `<p class="text-amber-600">Aktif Siparişler: ${vehicle.orderNos.join(', ')}</p>`;
        }
        
        // Hedef nokta varsa göster
        if (vehicle.planning && vehicle.planning.targetPointName) {
          warningHtml += `<p class="text-amber-600">Hedef Nokta: ${vehicle.planning.targetPointName}</p>`;
        }
        
        warningHtml += `</div>`;
        
        this.$swal.fire({
          title: 'Dikkat!',
          html: warningHtml,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#ef4444',
          cancelButtonColor: '#9ca3af',
          confirmButtonText: 'Evet, Ata',
          cancelButtonText: 'İptal'
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('assign', vehicle.id);
          }
        });
      } else {
        // Normal araç için basit onay
        this.$swal.fire({
          title: 'Araç Atama',
          html: `<div class="text-left">
            <p><strong>${vehicle.plate || vehicle.vehicle}</strong> plakalı aracı bu siparişe atamak istediğinizden emin misiniz?</p>
          </div>`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#ef4444',
          cancelButtonColor: '#9ca3af',
          confirmButtonText: 'Evet, Ata',
          cancelButtonText: 'İptal'
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit('assign', vehicle.id);
          }
        });
      }
    }
  }
};
</script>